// export const apiUrl = 'http://localhost:5000';
export const apiUrl = 'https://lagning.herokuapp.com';


// WEBPACK FOOTER //
// ./src/services/smartparking-api/apiUrl.js